/**
 * 五分钟(300000 毫秒)计时，获取token
 * @param {String} code为delivery_code
 * @param {Number} rememberTime为记住密码的时间
 */
export function getAuthToken(code, rememberTime = 300000) {
  const res = {
    hasToken: false,
    token: '',
  }
  if (!code) return res
  const token = localStorage.getItem(`linkToken${code}`) // 获取localstorage
  try {
    const tokenParsed = JSON.parse(token) || {}
    const curTime = new Date().getTime()
    // console.log('curTime=',curTime, tokenParsed, curTime - tokenParsed.startTime)
    if (curTime - tokenParsed.startTime <= rememberTime) {
      if (tokenParsed.token) {
        // console.log('token---',tokenParsed.token)
        Object.assign(res, { hasToken: true, ...tokenParsed })
        return res
      }
    } else {
      // console.log('hhh', tokenParsed, curTime)
      localStorage.removeItem(`linkToken${code}`)
      return res
    }
  } catch (e) {
    // console.log('eee', e)
    localStorage.removeItem(`linkToken${code}`)
    return res
  }
}
